import { useLocation } from 'react-router-dom';
import { AppRoute } from '../constants';

const pathnameIsAppRoute = (pathname: string): pathname is AppRoute => {
  const routes: string[] = Object.values(AppRoute);
  return routes.includes(pathname);
};

/**
 * @returns The current AppRoute or AppRoute.ROOT if the current path is not an AppRoute.
 */
export const useCurrentRoute = (): AppRoute => {
  const { pathname } = useLocation();

  return pathnameIsAppRoute(pathname) ? pathname : AppRoute.ROOT;
};
